import { useId, useMemo, useState } from "react";
import { Star } from "lucide-react";
import type { StarsReviewProps } from "../core/types/tsx/components/StarsReview.types";

export function StarsReview({ value, onChange, className = "" }: StarsReviewProps) {
	const id = useId();
	const name = `star-radio-${id}`;
	const [hovered, setHovered] = useState<number | null>(null);
	const displayValue = useMemo(() => hovered ?? value, [hovered, value]);

	return (
		<div className={className}>
			<div
				role='radiogroup'
				aria-label='Calificación'
				className='flex items-center justify-center gap-3'
				onMouseLeave={() => setHovered(null)}
			>
				{[1, 2, 3, 4, 5].map((star) => {
					const checked = value === star;
					const filled = star <= displayValue;

					return (
						<div key={star} className='relative'>
							<input
								className='sr-only'
								type='radio'
								id={`${name}-${star}`}
								name={name}
								value={star}
								checked={checked}
								onChange={() => onChange(star)}
							/>
							<label
								htmlFor={`${name}-${star}`}
								className='inline-flex cursor-pointer items-center justify-center rounded-md p-1 outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2'
								onMouseEnter={() => setHovered(star)}
								title={`${star} estrellas`}
							>
								<Star
									className={
										"h-8 w-8 transition-colors " + "text-[#894C00]"
									}
									fill={filled ? "currentColor" : "none"}
								/>
							</label>
						</div>
					);
				})}
			</div>
		</div>
	);
}
